import API from "@/services/api";
import { CheckFeaturesResponse, ErpFeatureKeys } from "../models/erpFeature";

enum Endpoints {
  checkForFeatures = "/erp_features/check_features",
}

export const checkForFeatures = (features: ErpFeatureKeys[]) => {
  return new Promise<CheckFeaturesResponse>(async (resolve, reject) => {
    API.get<CheckFeaturesResponse>({
      endpoint: Endpoints.checkForFeatures,
      searchParams: `?features=${features.join(",")}`,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}
